import { executeRequest, Request } from '@jfs/network'
import { APIEndPoints } from './APIEndPoints'
import { sitConfigWithTraceId } from './config'

const createEntityReq = (data: any, tokens: any, traceId: string) => {
  const request: Request<{}> = {
    config: sitConfigWithTraceId(tokens, traceId),
    apiPath: APIEndPoints.createEntity_camunda,
    body: data,
    method: 'POST',
    headers: sitConfigWithTraceId(tokens, traceId).headers,
  }
  return executeRequest(request)
    .then((data) => {
      return data
    })
    .catch((err) => {
      throw err
    })
}

export { createEntityReq }
